const PROVIDER_KEY = 'careers-app-auth-provider';

// Tracks which auth provider (Auth0 or DE Auth) last confirmed an authenticated session,
// so main.js can skip initializing the other provider on boot.
function getPersistedProvider() {
    return localStorage.getItem(PROVIDER_KEY);
}

function setPersistedProvider(provider) {
    localStorage.setItem(PROVIDER_KEY, provider);
}

function clearPersistedProvider() {
    localStorage.removeItem(PROVIDER_KEY);
}

// If we're in the middle of a provider's own OAuth callback, that provider must be
// trusted for this page load regardless of what's persisted - the marker won't
// reflect it yet (it's only set once the callback finishes and confirms auth).
function detectCallbackProvider() {
    if (window.location.pathname.includes('/oauth2/authorized')) return 'de';
    if (window.location.search.includes('code=') && window.location.search.includes('state=')) return 'auth0';
    return null;
}

// The provider to trust for this page load: an in-flight OAuth callback takes
// priority, then the persisted marker, then null (unknown/never logged in - both
// providers are relevant until one of them proves otherwise).
function getActiveProvider() {
    return detectCallbackProvider() || getPersistedProvider();
}

export { getPersistedProvider, setPersistedProvider, clearPersistedProvider, getActiveProvider };
